const url = "/andamentos";

export const initFormAndamento = {
  idenPtaMonitora: null,
  dataAndamento: "",
  descAndamento: "",
  ptaMonitora: null,
};

export function salvar(parm) {
  return new Promise(async (resolve, reject) => {
    let id = parm.get("idenAndamento"); // Ajuste aqui para obter o idenPtaMonitora do FormData

    if (id != 0) {
      await atualizar(parm).then((res) => {
        resolve(res);
      });
    } else {
      await criar(parm).then((res) => {
        resolve(res);
      });
    }
  });
}

export function atualizar(parm) {
  return new Promise((resolve, reject) => {
    let id = parm.get("idenAndamento");
    window.$http
      .put(`${url}/${id}`, parm) // Passar o FormData diretamente
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function criar(parm) {
  return new Promise((resolve, reject) => {
    let idenPtaMonitora = parm.get("idenPtaMonitora"); // Obter o idenPtaMonitora corretamente
    window.$http
      .post(`${url}/${idenPtaMonitora}`, parm) // Passar o FormData diretamente
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function excluir(idenPtaMonitora) {
  return new Promise((resolve, reject) => {
    window.$http
      .delete(`${url}/${idenPtaMonitora}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function downloadArquivoAndamento(idenArquivo) {
  return new Promise((resolve, reject) => {
    window.$http
      .get(`${url}/download/base64/${idenArquivo}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
